import DetailText from './DetailText';

export default DetailText;
